import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'SensorsMap',
      component: () => import(/* webpackChunkName: "sensorsMap" */ './views/maps/sensors/SensorsMap.vue')
    },  
    {
      path: '/sensorstatus',
      name: 'SensorStatusMenu',
      component: () => import(/* webpackChunkName: "SensorStatusMenu" */ './views/maps/sensors/SensorStatusMenu.vue' )
    },
    {
      path: '/management/providers',
      name: 'Providers',
      component: () => import(/* webpackChunkName: "providers" */ './views/management/providers/Providers.vue')
    },
    {
      path: '/management/datalevels',
      name: 'Datalevels',
      component: () => import(/* webpackChunkName: "datalevels" */ './views/management/datalevels/Datalevels.vue')
    },
    {
      path: '/management/components',
      name: 'Components',
      component: () => import(/* webpackChunkName: "components" */ './views/management/components/Components.vue')
    },
    {
      path: '/management/units',
      name: 'Units',
      component: () => import(/* webpackChunkName: "units" */ './views/management/units/Units.vue')
    },
    {
      path: '/management/sensors',
      name: 'sensors',
      component: () => import(/* webpackChunkName: "sensors" */ './views/management/sensors/Sensors.vue')
    },
    {
       path: '/observations',
       name: 'Observations',
       component: () => import(/* webpackChunkName: "observations" */ './views/observations/Observations.vue')
    }
    ,
    {
       path: '/observations/plot',
       name: 'ObservationsPlot',
       props: true,
       component: () => import(/* webpackChunkName: "plot" */ './views/observations/Plot.vue')
    }
    ,
    {
       path: '/qualitycontrol/qcsensors',
       name: 'Qualitycontrol',
       component: () => import(/* webpackChunkName: "qualitycontrol" */ './views/qualitycontrol/QCSensors.vue')
    },
    {
       path: '/datadownload',
       name: 'DataDownload',
       component: () => import(/* webpackChunkName: "qualitycontrol" */ './views/qualitycontrol/DataDownload.vue' )
    },
    {
       path: '/about',
       name: 'About',
       component: () => import(/* webpackChunkName: "qualitycontrol" */ './views/about/About.vue' )
    }  
  ]
})
